/**
 * 현재 API를 호출 중인지를 확인한다.
 * @param {*} state 
 * @returns {Boolean}
 */
const isCalling = (state) => {
  let result = false
  for (let key in state) {
    if (key !== 'isDelayed' && key !== 'timerId') {
      result = !!state[key]
      if (result) break
    }
  }
  return result
}
/**
 * apiName을 받아 해당 api가 호출 중인지를 확인한다. (동일 API 중복 호출 방지)
 * @param {*} state 
 * @returns {Boolean}
 */
const getApiCallValue = (state) => (apiName) =>  state[apiName]


/**
 * apiName을 받아 해당 api가 호출 중인지를 확인한다. (동일 API 중복 호출 방지)
 * @param {*} state 
 * @returns {Boolean}
 */

/**
 * 현재 API 호출 응답이 1초이상 지연이 되는지 확인한다. (spinner를 띄우기 위해 )
 * @param {*} state 
 * @returns {Boolean}
 */
const isDelayed = state => state.isDelayed

  
export default {
  isCalling,
  getApiCallValue,
  isDelayed
}
